const content = document.querySelector('.content');
const filters = content.querySelector('.filters__content');
const filtersOpenButton = content.querySelector('.filters__open-button');
const filtersCloseButton = content.querySelector('.filters__close-button');

if (filtersOpenButton)
    filtersOpenButton.addEventListener('click', () => {
        filters.classList.add('filters__content_active');
        document.body.classList.add('non-scrollable');
        content.style.zIndex = 4;
    });

if (filtersCloseButton)
    filtersCloseButton.addEventListener('click', () => {
        filters.classList.remove('filters__content_active');
        document.body.classList.remove('non-scrollable');
        content.style.zIndex = 1;
    });

$('body').on('click', '.tags__item', function(e) {
    const applyButton = document.querySelector('.filters__actions .button');
    applyButton.setAttribute('disabled', 'disabled');
    $('.tooltip').remove();
    let item = $(this);
    $(this).toggleClass('tags__item_active');
    let checkBox = $(this).find('input');
    checkBox.attr('checked', !checkBox.attr('checked'));
    let countActive = item
        .parents('.filters__list-item')
        .find('.tags__item_active');
    let headerPanel = item
        .parents('.filters__list-item')
        .find('.expansion-panel__header');
    let badge = headerPanel.find('.badge');
    if (badge.length && countActive.length) {
        badge.html(countActive.length);
    } else if (badge.length && countActive.length === 0) {
        badge.remove();
    } else {
        headerPanel.append(
            '<span class="badge">' + countActive.length + '</span>'
        );
    }
    let url = updateUrl(window.location.href);
    $.ajax({
        url: addParamsToUrl(url, 'ajax', true),
        type: 'get',
        success: function(response) {
            if (response.success) {
                applyButton.href = url;
                applyButton.removeAttribute('disabled');
                let html =
                    '<div class="tooltip tooltip_arrow-left">\n' +
                    '<span>' +
                    response.data.count +
                    '</span>\n' +
                    '<a href="' +
                    url +
                    '" class="link">' +
                    response.data.show +
                    '</a>\n' +
                    '</div>';
                item.parents('.tags').prepend(html);
            }
        }
    });
    console.log(url);
});

function updateUrl(url) {
    var tempArray = url.split('?');
    var baseURL = tempArray[0];
    var gets = tempArray[1] === undefined ? '' : tempArray[1];
    var arr = [];
    if (gets !== '') {
        let urlParams = new URLSearchParams(gets);
        arr = paramsToObject(urlParams.entries());
        arr = deleteFilter(arr, 'filter');
        arr = deleteFilter(arr, 'sort');
        arr = deleteFilter(arr, 'search');
        arr = deleteFilter(arr, 'direction');
        gets = '';
    }
    $('.filters__content input:checked').each(function() {
        if (arr.hasOwnProperty($(this).attr('name'))) {
            arr[$(this).attr('name')] += ';' + $(this).val();
        } else {
            arr[$(this).attr('name')] = $(this).val();
        }
    });
    let formSort = $('form.sorting__select').serializeArray();
    if (formSort.length) {
        formSort.forEach(function(key) {
            arr[key['name']] = key['value'];
        });
    }
    let formSearch = $('form.main-search').serializeArray();
    if (formSearch.length) {
        formSearch.forEach(function(key) {
            arr[key['name']] = key['value'];
        });
    }
    if (Object.keys(arr).length) {
        let newUrl = baseURL;
        for (let index in arr) {
            newUrl = addParamsToUrl(newUrl, index, arr[index]);
        }
        return newUrl.toString();
    }
    return baseURL;
}

function paramsToObject(entries) {
    const result = {};
    for (const [key, value] of entries) {
        result[key] = value;
    }
    return result;
}

function deleteFilter(arr, term) {
    let a = Object.keys(arr);
    let b = a.filter(item => item.toLowerCase().indexOf(term) > -1);
    if (b.length) {
        b.forEach(function(item) {
            delete arr[item];
        });
    }
    return arr;
}

function addParamsToUrl(currentUrl, name, val) {
    let url = new URL(currentUrl);
    url.searchParams.append(name, val);
    return url.toString();
}

$(document).ready(function() {
    let loadMore = true;
    $('body').on('click', '.load-more-product', function(e) {
        e.preventDefault();
        let mainBlock = $(this).parents('.products');
        if (loadMore) {
            loadMore = false;
            $.ajax({
                url: $(this).data('href'),
                type: 'get',
                processData: false,
                contentType: false,
                success: function(response) {
                    let block = $(response).find('.product-list');
                    let lists = block.find('li');
                    $.each(lists, function(k, item) {
                        mainBlock.find('.product-list').append(item);
                    });
                    let btn = block.find('.load-button');
                    if (btn.length) {
                        mainBlock
                            .find('.load-button')
                            .attr('href', btn.attr('href'));
                    } else {
                        mainBlock.find('.load-button').hide();
                    }
                }
            }).always(function() {
                loadMore = true;
            });
        }
    });

    $('body').on('change', '.sorting__radios [name="sort"]', function(e) {
        let value = $(this).val();
        $('.sorting__select select').val(value);
        $('form.sorting__select').submit();
    });

    $('body').on('change', '.sorting__select .select', function(e) {
        let form = $(this).parents('form');
        form.submit();
    });

    $('body').on('submit', 'form.sorting__select, form.main-search', function(
        e
    ) {
        e.preventDefault();
        window.location.href = updateUrl(window.location.href);
    });

    $('body').on('click', '.sorting__radio input:checked + label', function(e) {
        let direction = $('[name="direction"]');
        console.log(direction);
        direction.attr('checked', !direction.attr('checked'));
        $('form.sorting__select').submit();
    });
});
